import type { CargoRes } from 'api/swagger';

export const countTotalPallets = (cargo: CargoRes): number => {
  return cargo.statuses.reduce((acc, status) => acc + status.count, 0);
};
